// import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";

export function DiorRegisterModel() {
    this.memberCode = '';
    this.lineUserId = '';
    this.firstname = '';
    this.lastname = '';
    this.birthyear = '';
    this.birthmonth = '';
    this.birthday = '';
    this.email = '';
    this.contactNumber = '';
    this.address = null; // AddressModel
    this.prefix = "";

    this.getParams = function() {
        console.log("getparam register");
        // var localeCode = Locale.getLocaleCode();
        var params = {
            //mid: this.lineUserId,
            firstname: this.firstname,
            surname: this.lastname,
            birthyear: this.birthyear,
            birthmonth: this.birthmonth,
            birthday: this.birthday,
            email: this.email,
            contactnumber: this.contactNumber,
            address: this.address.strAddress,
            // province: localeCode == 1033 ? this.address.strProvinceNameEn : this.address.strProvinceName,
            // district: localeCode == 1033 ? this.address.strDistrictNameEn : this.address.strDistrictName,
            // subdistrict: localeCode == 1033 ? this.address.strSubDistrictNameEn : this.address.strSubDistrictName,
            province: this.address.strProvinceName,
            district: this.address.strDistrictName,
            subdistrict: this.address.strSubDistrictName,
            zipcode: this.address.strZipcode,
            prefix: this.prefix,

        };

        params = Util.cleanObjectEmptyStr(params);
        return params;
    };
}

export function DiorRegisterBuilder() {

}
